import { ScenarioMetrics } from "in_queue/types/scenarioMetricsType";
import { formatCosts, formatDollarsPerMw } from "in_queue/utils/formatting";

/** The field both project charts plot on their Y axis. */
export type ChartMetric = "RANK" | "TOTAL_COST" | "COST_PER_MW";

export const CHART_METRICS: ReadonlyArray<ChartMetric> = [
    "RANK",
    "TOTAL_COST",
    "COST_PER_MW"
];

export const CHART_METRIC_LABELS: Record<ChartMetric, string> = {
    RANK: "Rank",
    TOTAL_COST: "Total cost",
    COST_PER_MW: "Cost per MW"
};

export const CHART_METRIC_AXIS_LABELS: Record<ChartMetric, string> = {
    RANK: "Rank by $/MW (P100 = most expensive)",
    TOTAL_COST: "Cost ($)",
    COST_PER_MW: "Cost ($/MW)"
};

/** The plotted value for one scenario; undefined when it has none. */
export const chartMetricValue = (
    metrics: ScenarioMetrics | undefined,
    metric: ChartMetric
): number | undefined => {
    if (metrics === undefined) return undefined;
    switch (metric) {
        case "RANK":
            return metrics.rankPercentile;
        case "TOTAL_COST":
            return metrics.sumAllocatedCost;
        case "COST_PER_MW":
            return metrics.costPerMw;
    }
};

export const formatChartMetric = (
    metric: ChartMetric,
    value: number
): string => {
    switch (metric) {
        case "RANK":
            return `p${Math.round(value)}`;
        case "TOTAL_COST":
            return formatCosts(value);
        case "COST_PER_MW":
            return formatDollarsPerMw(value);
    }
};

/** Signed difference from the base scenario, in the metric's own units. */
export const formatChartMetricDelta = (
    metric: ChartMetric,
    delta: number
): string => {
    const sign = delta >= 0 ? "+" : "";
    // A percentile difference is a count of points, not a P-value.
    if (metric === "RANK") return `${sign}${Math.round(delta)} pts`;
    return `${sign}${formatChartMetric(metric, delta)}`;
};
